module.exports = __webpack_public_path__ + "static/media/hp_bg_join.aa7e2618.svg";